<div class="aging-summary card">
    <div id="aging-summary-card">
        <card i18n-headerTitle headerTitle="Aging Summary" [hasFooter]="false">
            <div card-body class="card-body">
                <lsq-icon
                    *ngIf="!!tooltipText"
                    [attr.tabindex]="0"
                    [type]="icons.QuestionCircleLight"
                    [popoverOnHover]="true"
                    [height]="14"
                    [width]="14"
                    [popover]="tooltipText"
                    [placement]="tooltipPlacement"
                    [popoverPlacement]="tooltipPlacement"
                    [color]="color.Slate"
                >
                </lsq-icon>
                <lsq-circle-loader
                    *ngIf="agingOverviewDataSource.loading$ | async"
                ></lsq-circle-loader>
                <div class="chart-section" *ngIf="!(agingOverviewDataSource.loading$ | async)">
                    <div
                        class="chart-container"
                        *ngIf="invoiceCount > 0 && (agingOverviewData$ | async)"
                    >
                        <div
                            class="chart-center"
                            *ngIf="!(agingOverviewDataSource.loading$ | async)"
                        >
                            <div class="number-of-invoices">
                                {{ invoiceCount | number }}
                            </div>
                            <div
                                class="invoices-label"
                                i18n="invoices count label for doughnut graph"
                            >
                                {invoiceCount, plural, =1 {invoice} other {invoices}}
                            </div>
                            <div *ngIf="agingOverviewData$ | async" class="total-dollar-amount">
                                {{
                                    (agingOverviewData$ | async).amountCurrent +
                                        (agingOverviewData$ | async).amountDayOne +
                                        (agingOverviewData$ | async).amountDayThirtyOne +
                                        (agingOverviewData$ | async).amountDaySixtyOne | currency
                                }}
                            </div>
                        </div>
                        <lsq-chart
                            class="doughnut-chart"
                            [options]="chartOptions"
                            [colors]="colors"
                            [labels]="labels"
                            [data]="chartData"
                        >
                        </lsq-chart>
                    </div>
                    <div
                        class="chart-container"
                        *ngIf="(agingOverviewData$ | async)?.invoiceCount === 0"
                    >
                        <div
                            *ngIf="!debtorKey"
                            class="chart-center chart-blank-slate"
                            i18n="Message displayed when the invoice aging chart has no data"
                        >
                            There are no open invoices to display right now.
                        </div>
                        <div
                            *ngIf="debtorKey"
                            class="chart-center chart-blank-slate"
                            i18n="
                                Message displayed when the invoice aging chart for a customer has no
                                data
                            "
                        >
                            There are no open invoices with this customer right now.
                        </div>
                        <lsq-chart
                            class="doughnut-chart"
                            [options]="chartOptions"
                            [colors]="[blankChartColor]"
                            [labels]="labels"
                            [data]="[100]"
                        >
                        </lsq-chart>
                    </div>
                    <div class="chart-legend">
                        <div class="chart-legend-section">
                            <div
                                class="chart-legend-dot"
                                [style.background-color]="colors[0]"
                            ></div>
                            <span class="chart-legend-label text-uppercase">{{ labels[0] }}</span>
                            <div class="chart-legend-dollar">
                                {{ (agingOverviewData$ | async)?.amountCurrent || 0 | currency }}
                            </div>
                            <div class="chart-legend-percent">
                                {{ (agingOverviewData$ | async)?.percentCurrent || 0 | percent }}
                            </div>
                        </div>
                        <div class="chart-legend-section">
                            <div
                                class="chart-legend-dot"
                                [style.background-color]="colors[1]"
                            ></div>
                            <span class="chart-legend-label text-uppercase">{{ labels[1] }}</span>
                            <div class="chart-legend-dollar">
                                {{ (agingOverviewData$ | async)?.amountDayOne || 0 | currency }}
                            </div>
                            <div class="chart-legend-percent">
                                {{ (agingOverviewData$ | async)?.percentDayOne || 0 | percent }}
                            </div>
                        </div>
                        <div class="chart-legend-section">
                            <div
                                class="chart-legend-dot"
                                [style.background-color]="colors[2]"
                            ></div>
                            <span class="chart-legend-label text-uppercase">{{ labels[2] }}</span>
                            <div class="chart-legend-dollar">
                                {{
                                    (agingOverviewData$ | async)?.amountDayThirtyOne || 0 | currency
                                }}
                            </div>
                            <div class="chart-legend-percent">
                                {{
                                    (agingOverviewData$ | async)?.percentDayThirtyOne || 0 | percent
                                }}
                            </div>
                        </div>
                        <div class="chart-legend-section">
                            <div
                                class="chart-legend-dot"
                                [style.background-color]="colors[3]"
                            ></div>
                            <span class="chart-legend-label text-uppercase">{{ labels[3] }}</span>
                            <div class="chart-legend-dollar">
                                {{
                                    (agingOverviewData$ | async)?.amountDaySixtyOne || 0 | currency
                                }}
                            </div>
                            <div class="chart-legend-percent">
                                {{
                                    (agingOverviewData$ | async)?.percentDaySixtyOne || 0 | percent
                                }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
    </div>
</div>
<div class="row row-spacer">
    <div *ngIf="debtorKey && metricsDataSource" class="col-lg-6">
        <div id="metrics-card" [ngClass]="{ card: !isMobile }">
            <div *ngIf="!isMobile" class="card-header" i18n="Metrics card header">
                Metrics
            </div>
            <div [ngClass]="{ 'card-body': !isMobile }" class="metrics-body">
                <div *ngIf="metricsDataSource.loading$ | async" class="container-fluid">
                    <lsq-circle-loader></lsq-circle-loader>
                </div>
                <div *ngIf="!(metricsDataSource.loading$ | async)" class="metrics-inner">
                    <div class="metrics-item mobile-amount-cluster-card text-right narrow">
                        <dashboard-amount-cluster
                            label="# of Invoices Purchased"
                            i18n-label="# of Invoices Purchased customer metrics dashboard label"
                            [value]="(metricsData$ | async)?.metrics?.purchasedInvoiceCount"
                        >
                        </dashboard-amount-cluster>
                    </div>
                    <div class="metrics-item mobile-amount-cluster-card text-right narrow">
                        <dashboard-amount-cluster
                            [usePercentPipe]="true"
                            label="Dilution Rate"
                            i18n-label="Dilution Rate customer metrics dashboard label"
                            tooltipText="The percentage difference between the amount that you invoiced your customer and what your customer actually paid."
                            i18n-tooltipText="Dilution Rate customer metrics dashboard tooltip"
                            [value]="(metricsData$ | async)?.metrics?.dilution"
                        >
                        </dashboard-amount-cluster>
                    </div>
                    <div class="metrics-item mobile-amount-cluster-card text-right wide">
                        <dashboard-amount-cluster
                            [useCurrencyPipe]="true"
                            label="Average Invoice Size"
                            i18n-label="Average Invoice Size customer metrics dashboard label"
                            [value]="(metricsData$ | async)?.metrics?.averageInvoiceSize"
                        >
                        </dashboard-amount-cluster>
                    </div>
                    <div class="metrics-item mobile-amount-cluster-card text-right narrow">
                        <dashboard-amount-cluster
                            label="# of Invoices Paid"
                            i18n-label="# of Invoices Paid customer metrics dashboard label"
                            [value]="(metricsData$ | async)?.metrics?.paidInvoiceCount"
                        >
                        </dashboard-amount-cluster>
                    </div>
                    <div class="metrics-item mobile-amount-cluster-card text-right narrow">
                        <dashboard-amount-cluster
                            label="Average Days to Pay"
                            i18n-label="Average Days to Pay customer metrics dashboard label"
                            tooltipText="The average number of days it takes for your customer to pay your invoices."
                            i18n-tooltipText="
                                Average Days to Pay customer metrics dashboard tooltip
                            "
                            [value]="
                                (metricsData$ | async)?.metrics?.averageDaysToPay || nullAmount
                            "
                        >
                        </dashboard-amount-cluster>
                    </div>
                    <div class="metrics-item mobile-amount-cluster-card text-right wide">
                        <dashboard-amount-cluster
                            [useCurrencyPipe]="!!(metricsData$ | async)?.metrics?.lastPaymentAmount"
                            label="Last Payment Received"
                            i18n-label="Last Payment Received customer metrics dashboard label"
                            [value]="
                                (metricsData$ | async)?.metrics?.lastPaymentAmount || nullAmount
                            "
                        >
                        </dashboard-amount-cluster>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
